<template>
  <img src="../assets/EDMap.jpg" class="img-fluid" alt="..." />
</template>
<script>
export default {
  name: "EDMap",
};
</script>
<style scoped></style>
